export default __webpack_public_path__ + "static/media/cemredort3.040f9afa.jpg";